// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article {
  margin: 2rem auto 7rem auto;
}

.artcile__title {
  font-size: 1.8rem;
  margin-bottom: 1rem;
}

.article__head {
  width: 100%;
  position: relative;
}
.article__contentHeader {
  padding-bottom: 3em;
  border-bottom: 0.1rem solid var(--clr-gray500);
}

.article__contentHeader h1 {
  font-size: 2rem;
  line-height: 1.25;
  margin: 0 auto;
  margin-top: 1.5rem;
  color: var(--clr-primary);
  font-weight: 400;
  max-width: 40rem;
}

.article__author {
  display: flex;
  align-items: center;
  margin-top: 2rem;
}

.article__authorImgContainer {
  position: relative;
}

.article__authorImgContainer img {
  width: 3.5rem;
  height: 3.5rem;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 1rem;
}

.article__author h4 {
  margin-bottom: 0.25rem;
}

.article__author span,
.article__author h4 {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--clr-dark);
  font-family: "Avenir Next";
}

.article__authorImgContainer svg {
  display: none;
}

.article__mainImg {
  width: 100%;
  display: block;
  object-fit: cover;
  border-radius: 1.5em;
  height: 100%;
  max-height: 37rem;
}

.article__content {
  width: 100%;
  margin: 3rem auto 0 auto;
  max-width: 40rem;
  line-height: 2;
}

.article__content ul {
  list-style: unset;
  padding-left: 1em;
}

.article__content img {
  width: 100%;
  max-height: 35rem;
  object-fit: contain;
  border-radius: 0.5em;
}

.article__content figcaption {
  display: none;
}

.article__videoContainer {
  position: relative;
}

.article__video {
  width: 100%;
  /* max-width: max-content; */
  /* height: 35rem; */
  /* height: 10rem; */
  /* max-height: 35rem; */
  aspect-ratio: 2 / 1.25;
  border-radius: 2em;
  margin-top: 1rem;
  object-fit: cover;
}

.article__startIcon {
  width: 100%;
  max-width: 5rem;
  /* max-width: 10rem; */
  position: absolute;
  left: 50%;
  top: 50%;
  cursor: pointer;
  transform: translate(-50%, -50%);
}

.article__movePage {
  display: flex;
  margin-top: 3rem;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
}

.article__movePage button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  padding: 1em 0.75em;
  white-space: nowrap;
  width: 100%;
  max-width: 11rem;
  border-radius: 1em;
}

.article__movePage button svg {
  width: 0.5rem;
  display: block;
}

.article__movePage button:last-of-type {
  margin-left: auto;
}

.article__moreArticle {
  margin-top: 4rem;
}

.article__moreArticle h2 {
  margin-bottom: 2rem;
}

.article__moreArticleCards {
  display: grid;
  gap: 3rem;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
}

.article__prevBtn {
  margin-left: 0 !important;
}

@media (min-width: 375px) {
  /* .article__video {
    height: 15rem;
  } */
  .article__contentHeader h1 {
    font-size: 2.5rem;
  }
}
@media (min-width: 425px) {
  /* .article__video {
    height: 20rem;
  } */

  .article__movePage button {
    gap: 0.5rem;
    font-size: 0.8rem;
    padding: 1.25em 1.5em;
    max-width: 11rem;
  }
}

@media (min-width: 500px) {
  .article__movePage button {
    font-size: 1rem;
    max-width: 13rem;
  }
}

@media (min-width: 768px) {
  .article {
    margin-top: 4rem;
  }

  /* .article__contentHeader {
    position: absolute;
    left: 0;
    right: 0;
    width: 80%;
    height: 20rem;
    max-height: 28rem;
    margin: 0 auto;
    bottom: -7.5rem;
    color: var(--clr-light);
    border: 2px solid transparent;
    -webkit-font-smoothing: antialiased;
    background-clip: padding-box;
    -moz-osx-font-smoothing: grayscale;
    background: rgba(19, 19, 42, 0.25);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(2em);
    padding: 2em 7em;
    border-radius: 1em;
  }

  .article__contentHeader h1 {
    color: var(--clr-light);
    margin-top: 0;
  } */

  .article__contentHeader {
    border: none;
    padding-bottom: 0;
  }

  .article__author span,
  .article__author h4 {
    color: var(--clr-light);
  }

  .article__authorImgContainer svg {
    display: block;
    position: absolute;
    width: 2rem;
    right: 0.5rem;
    bottom: -0.5rem;
  }

  /* .article__video {
    height: 25rem;
  } */

  .article__startIcon {
    max-width: 7rem;
  }

  .article__content {
    margin: 0 auto;
  }
}

@media (min-width: 992px) {
  .artcile__title {
    margin-bottom: 2rem;
    font-size: 3.5rem;
  }

  .article__contentHeader h1 {
    font-size: 3rem;
  }

  .article__moreArticle {
    margin-top: 7rem;
  }
}

/* @media (min-width: 1200px) {
  .article__contentHeader h1 {
    font-size: 4rem;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/pages/Article/Article.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;KAEG;EACH;IACE,iBAAiB;EACnB;AACF;AACA;EACE;;KAEG;;EAEH;IACE,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;KAwBG;;EAEH;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA;;KAEG;;EAEH;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;GAIG","sourcesContent":[".article {\n  margin: 2rem auto 7rem auto;\n}\n\n.artcile__title {\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n}\n\n.article__head {\n  width: 100%;\n  position: relative;\n}\n.article__contentHeader {\n  padding-bottom: 3em;\n  border-bottom: 0.1rem solid var(--clr-gray500);\n}\n\n.article__contentHeader h1 {\n  font-size: 2rem;\n  line-height: 1.25;\n  margin: 0 auto;\n  margin-top: 1.5rem;\n  color: var(--clr-primary);\n  font-weight: 400;\n  max-width: 40rem;\n}\n\n.article__author {\n  display: flex;\n  align-items: center;\n  margin-top: 2rem;\n}\n\n.article__authorImgContainer {\n  position: relative;\n}\n\n.article__authorImgContainer img {\n  width: 3.5rem;\n  height: 3.5rem;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-right: 1rem;\n}\n\n.article__author h4 {\n  margin-bottom: 0.25rem;\n}\n\n.article__author span,\n.article__author h4 {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--clr-dark);\n  font-family: \"Avenir Next\";\n}\n\n.article__authorImgContainer svg {\n  display: none;\n}\n\n.article__mainImg {\n  width: 100%;\n  display: block;\n  object-fit: cover;\n  border-radius: 1.5em;\n  height: 100%;\n  max-height: 37rem;\n}\n\n.article__content {\n  width: 100%;\n  margin: 3rem auto 0 auto;\n  max-width: 40rem;\n  line-height: 2;\n}\n\n.article__content ul {\n  list-style: unset;\n  padding-left: 1em;\n}\n\n.article__content img {\n  width: 100%;\n  max-height: 35rem;\n  object-fit: contain;\n  border-radius: 0.5em;\n}\n\n.article__content figcaption {\n  display: none;\n}\n\n.article__videoContainer {\n  position: relative;\n}\n\n.article__video {\n  width: 100%;\n  /* max-width: max-content; */\n  /* height: 35rem; */\n  /* height: 10rem; */\n  /* max-height: 35rem; */\n  aspect-ratio: 2 / 1.25;\n  border-radius: 2em;\n  margin-top: 1rem;\n  object-fit: cover;\n}\n\n.article__startIcon {\n  width: 100%;\n  max-width: 5rem;\n  /* max-width: 10rem; */\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  cursor: pointer;\n  transform: translate(-50%, -50%);\n}\n\n.article__movePage {\n  display: flex;\n  margin-top: 3rem;\n  gap: 0.5rem;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.article__movePage button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  padding: 1em 0.75em;\n  white-space: nowrap;\n  width: 100%;\n  max-width: 11rem;\n  border-radius: 1em;\n}\n\n.article__movePage button svg {\n  width: 0.5rem;\n  display: block;\n}\n\n.article__movePage button:last-of-type {\n  margin-left: auto;\n}\n\n.article__moreArticle {\n  margin-top: 4rem;\n}\n\n.article__moreArticle h2 {\n  margin-bottom: 2rem;\n}\n\n.article__moreArticleCards {\n  display: grid;\n  gap: 3rem;\n  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));\n}\n\n.article__prevBtn {\n  margin-left: 0 !important;\n}\n\n@media (min-width: 375px) {\n  /* .article__video {\n    height: 15rem;\n  } */\n  .article__contentHeader h1 {\n    font-size: 2.5rem;\n  }\n}\n@media (min-width: 425px) {\n  /* .article__video {\n    height: 20rem;\n  } */\n\n  .article__movePage button {\n    gap: 0.5rem;\n    font-size: 0.8rem;\n    padding: 1.25em 1.5em;\n    max-width: 11rem;\n  }\n}\n\n@media (min-width: 500px) {\n  .article__movePage button {\n    font-size: 1rem;\n    max-width: 13rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .article {\n    margin-top: 4rem;\n  }\n\n  /* .article__contentHeader {\n    position: absolute;\n    left: 0;\n    right: 0;\n    width: 80%;\n    height: 20rem;\n    max-height: 28rem;\n    margin: 0 auto;\n    bottom: -7.5rem;\n    color: var(--clr-light);\n    border: 2px solid transparent;\n    -webkit-font-smoothing: antialiased;\n    background-clip: padding-box;\n    -moz-osx-font-smoothing: grayscale;\n    background: rgba(19, 19, 42, 0.25);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(2em);\n    padding: 2em 7em;\n    border-radius: 1em;\n  }\n\n  .article__contentHeader h1 {\n    color: var(--clr-light);\n    margin-top: 0;\n  } */\n\n  .article__contentHeader {\n    border: none;\n    padding-bottom: 0;\n  }\n\n  .article__author span,\n  .article__author h4 {\n    color: var(--clr-light);\n  }\n\n  .article__authorImgContainer svg {\n    display: block;\n    position: absolute;\n    width: 2rem;\n    right: 0.5rem;\n    bottom: -0.5rem;\n  }\n\n  /* .article__video {\n    height: 25rem;\n  } */\n\n  .article__startIcon {\n    max-width: 7rem;\n  }\n\n  .article__content {\n    margin: 0 auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .artcile__title {\n    margin-bottom: 2rem;\n    font-size: 3.5rem;\n  }\n\n  .article__contentHeader h1 {\n    font-size: 3rem;\n  }\n\n  .article__moreArticle {\n    margin-top: 7rem;\n  }\n}\n\n/* @media (min-width: 1200px) {\n  .article__contentHeader h1 {\n    font-size: 4rem;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
